module.exports = __webpack_public_path__ + "media/images/eu5-185367dc2375996582ad77d99e5e4d53.svg";